import Chart from "chart.js/auto";
import "chartjs-adapter-moment";

Chart.defaults.font.family = "Inter";
